import {
    buildTrailingDateRange,
    buildYearToDateRange
} from "@therapprove/common";
import { DashboardDateShortcut } from "./types";

export const DASHBOARD_DATE_SHORTCUTS: DashboardDateShortcut[] = [
    { label: "Last 7 Days", getValue: () => buildTrailingDateRange(7) },
    { label: "Last 30 Days", getValue: () => buildTrailingDateRange(30) },
    { label: "Last 90 Days", getValue: () => buildTrailingDateRange(90) },
    { label: "Year to Date", getValue: () => buildYearToDateRange() },
    { label: "All Time", getValue: () => [null, null] }
];

export const DEFAULT_DASHBOARD_DATE_RANGE = buildTrailingDateRange(30);
